import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { reduxForm, Field } from 'redux-form'
import { LAYOUT_NAME_MAX_LENGTH } from 'const/limits'
import {
  FormGroup,
  ControlLabel,
  HelpBlock,
  Button,
} from 'react-bootstrap'
import Textarea from 'components/Textarea'
import TemplateField from './TemplateField'

export class AddNewLayoutForm extends React.Component {
  static propTypes = {
    isTemplate: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.props.handleSubmit()
    }
  }

  renderNameField = (field) => {
    return (
      <FormGroup
        controlId='addCardName'
        validationState={field.meta.touched && field.meta.error ? 'error' : null}
      >
        <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
        <Textarea
          {...field.input}
          name={null}
          autoFocus
          maxLength={LAYOUT_NAME_MAX_LENGTH}
          onKeyDown={this.handleKeyDown}
        />
        {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }

  render () {
    const {
      isTemplate,
      handleSubmit,
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        {!isTemplate &&
          <Field
            name='template'
            component={TemplateField}
          />
        }
        <Field
          name='name'
          component={this.renderNameField}
        />
        <Button type='submit' bsStyle='primary'><FormattedMessage id='ADD' /></Button>
      </form>
    )
  }
}

export default reduxForm({
  form: 'addNewLayoutForm',
  initialValues: {
    template: 'empty',
  }
})(AddNewLayoutForm)
